var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-wrap"},_vm._l((_vm.units),function(item,index){return _c('div',{key:index},[(_vm.editorIndex == index)?_c('preview',{attrs:{"mode":"2","info":item,"pre":_vm.pre}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }